import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Star, Building2, TrendingUp, Users } from "lucide-react";

const B2BTestimonials = () => {
  const testimonials = [
    {
      quote: "VGP transformed our pipeline. We went from unpredictable lead flow to consistent, qualified opportunities every month. Our sales team finally has the volume they need.",
      name: "James Richardson",
      title: "VP Sales",
      company: "Enterprise SaaS Company",
      metric: "340% pipeline increase",
      metricIcon: TrendingUp
    },
    {
      quote: "The LinkedIn SDR campaigns exceeded expectations. We are booking 15-20 qualified calls per month with decision-makers at our target accounts.",
      name: "Sarah Mitchell",
      title: "Head of Marketing",
      company: "B2B Professional Services",
      metric: "20+ calls/month",
      metricIcon: Users
    },
    {
      quote: "Finally, a marketing partner that understands B2B. They focus on metrics that matter - pipeline and revenue, not vanity metrics.",
      name: "David Chen",
      title: "CEO",
      company: "Tech Scale-Up",
      metric: "45% shorter sales cycle",
      metricIcon: Building2
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-secondary/5">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <Badge variant="secondary" className="mb-4">Client Results</Badge>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
              What B2B Leaders Say
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
              Results from companies who chose to build predictable growth engines.
            </p>
          </div>

          {/* Testimonials Grid */}
          <div className="grid lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => {
              const MetricIcon = testimonial.metricIcon;
              return (
                <Card key={index} className="border-border/50 hover:shadow-lg transition-all duration-300">
                  <CardContent className="pt-6">
                    {/* Stars */}
                    <div className="flex gap-1 mb-4">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} className="w-4 h-4 fill-accent text-accent" />
                      ))}
                    </div>

                    {/* Quote */}
                    <p className="text-foreground mb-6 leading-relaxed">
                      &ldquo;{testimonial.quote}&rdquo;
                    </p>

                    {/* Metric Badge */}
                    <div className="flex items-center gap-2 mb-6 p-3 bg-accent/10 rounded-lg">
                      <MetricIcon className="w-5 h-5 text-accent" />
                      <span className="font-bold text-foreground">{testimonial.metric}</span>
                    </div>

                    {/* Author */}
                    <div className="border-t border-border pt-4">
                      <p className="font-semibold text-foreground">{testimonial.name}</p>
                      <p className="text-sm text-muted-foreground">{testimonial.title}</p>
                      <p className="text-sm text-muted-foreground">{testimonial.company}</p>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default B2BTestimonials;
